import React from "react";

export default function Research() {
  return (
    <section id="research">
      <h2>Research & Academic Interests</h2>

      <p>
        Harpreet Singh has an academic and professional interest in
        computer science, software development, web technologies,
        information technology, and emerging technologies.
      </p>

      <p>
        His experience includes keeping up with developments in software
        engineering and introducing students and team members to modern
        technologies and development practices.
      </p>
    </section>
  );
}
